import React, { Component } from 'react';

class OpeningHours extends Component {
  render() {
    return (
      <div className="opening-hours">
        <p>HOURS</p>
        <p>MONDAY–FRIDAY, 12 PM.–6 PM.</p>
        <p>and by appointment.<a className="email-inline" href="mailto:info@anywaysnyc.com"></a></p>
      </div>
    );
  }
}

export default OpeningHours;



// WEBPACK FOOTER //
// ./src/components/Space/OpeningHours.js